import React from "react";
import PropTypes from "prop-types";
import { FeaturedIcon } from "./icons/FeaturedIcon";

const Tag = ({ small = false, color = "secondary", tag, isFeatured = false }) => {
  if (isFeatured) {
    return (
      <span
        className={`text-base rounded font-bold px-4 py-4 inline-block tracking-wide cursor-default w-full mx-1 mb-2 mt-0 flex items-center`}
        style={{ backgroundColor: "#E8F2F9", color: "#1C6094" }}
      >
        <FeaturedIcon />
        {tag}
      </span>
    );
  }

  if (small) {
    return (
      <span
        className={`paragraph--extra-small rounded font-bold bg-white text-${color} border border-${color} px-1 py-1 m-1 inline-block tracking-wide cursor-default`}
      >
        {tag}
      </span>
    );
  }

  return (
    <span
      className={`paragraph--small rounded font-bold bg-white text-${color} border border-${color} px-2 py-1 m-1 inline-block tracking-wide cursor-default`}
    >
      {tag}
    </span>
  );
};

Tag.propTypes = {
  color: PropTypes.string,
  tag: PropTypes.string.isRequired,
  isFeatured: PropTypes.bool,
  small: PropTypes.bool,
};

export default Tag;
